<ng-template #template>
  <div tabindex="-1" class="svc-matrix-cell" (click)="selectContext($event)"
    (mouseover)="adorner.hover($event, $event.currentTarget)"
    (mouseleave)="adorner.hover($event, $event.currentTarget)">
    <div class="svc-matrix-cell--selected" [class.svc-visible]="adorner.isSelected"></div>
    <ng-container *ngTemplateOutlet="contentTempl"></ng-container>
    <div *ngIf="isSupportCellEditor" class="svc-matrix-cell__question-controls">
      <span class="svc-matrix-cell__question-controls-button svc-context-button"
        (click)="adorner.editQuestion(adorner, $event)" [key2click]>
        <svg [iconName]="'icon-edit'" [size]="'auto'" [size]="'auto'" sv-ng-svg-icon></svg>
      </span>
    </div>
  </div>
</ng-template>